<template>
  <div class="toggle-switch" @click="switchChanged">
    <input class="toggle-switch-checkbox" :id="toggleName" name="toggleName" @change="switchChanged" v-model="switchStatus" type="checkbox" />
    <label class="toggle-switch-label" :for="toggleName">
      <span class="opposite on" v-if="!switchStatus && text">{{text.on}}</span>
      <span class="opposite off" v-if="switchStatus && text">{{text.off}}</span>
      <span class="toggle-switch-inner"></span>
      <span v-if="!text" class="toggle-switch-switch icon" :class="{'icon-check' : switchStatus, 'icon-close' :!switchStatus}"></span>
      <span v-if="text" class="toggle-switch-switch text">
        <span v-if="switchStatus">{{text.on}}</span>
        <span v-if="!switchStatus">{{text.off}}</span>
      </span>
    </label>
  </div>
</template>

<script>

  export default {
    name: "ToggleSwitch",
    props: ['toggleName','status','text'],
    data: function () {
      return {
        switchStatus: null
      }
    },
    watch: {
      status :function (val) {
        this.switchStatus = val
      }
    },
    methods: {
      switchChanged(e) {
        this.switchStatus = !this.switchStatus
        this.$emit('switchChanged', this.switchStatus, e)
      }
    },
    mounted() {
      this.switchStatus = this.status
    }
  };
</script>
<style lang="scss">
  @import "../../../assets/scss/abstract/_variables.scss";

  .toggle-switch {
    position: relative;
    width: 54px;
    direction: ltr;
    display: block;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select: none;
  }

  .toggle-switch-checkbox {
    display: none;
  }

  .toggle-switch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border-radius: 20px;
  }

  .opposite{
    position: absolute;
    text-align: center;
    line-height: 38px;
    right: 33px;
    color: #838ea5;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    &.off{
      left: -40px;
    }
  }

  .toggle-switch-inner {
    display: block; width: 200%; margin-left: -100%;
    transition: margin 0.3s ease-in 0s;

    &:before, &:after {
      content: '';
      display: block;
      float: left;
      width: 50%;
      height: 30px;
      padding: 0;
      line-height: 30px;
      font-size: 14px;
      color: white;
      font-family: Trebuchet, Arial, sans-serif;
      font-weight: bold;
      box-sizing: border-box;

    }

    &:before {
      padding-left: 10px;
      background-color: $active_dot;
      color: #eaedf2;
    }

    &:after {
      padding-right: 10px;
      background-color: #eaedf2;
      color: red;
      text-align: right;
    }
  }

  .toggle-switch-switch {
    display: block;
    width: 23px;
    height: 23px;
    margin-left: 3px;
    background-color: #4d5d7e;
    color: #eaedf2;
    background: $active_dot;
    color: #ffffff;
    text-align: center;
    position: absolute;
    top: 3px;
    bottom: 0;
    font-size: 18px;
    line-height: 25px;
    border-radius: 20px;
    transition: all 0.2s ease-in 0s;

    &.text{
      font-size: 9px;
      font-weight: 600;
      line-height: 24px;
      text-transform: uppercase;
    }
  }

  .toggle-switch-checkbox:checked + .toggle-switch-label .toggle-switch-inner {
    margin-left: 0;
  }

  .toggle-switch-checkbox:checked + .toggle-switch-label .toggle-switch-switch {
    right: 3px;
    background-color: #ffffff;
    color: $active_dot;
    font-size: 14px;

    &.text{
      font-size: 9px;
      font-weight: 600;
      line-height: 24px;
    }
  }

</style>
